'use strict'
require('core-js/modules/es.array.concat')
exports.__esModule = true
exports.default = exports.maxPartVals = exports.DEFAULT_FMT_MASK = exports.MAX_SEC_IN_HOUR = exports.MAX_SEC_IN_DAY = exports.ONE_DAY_MS = exports.ONE_HOUR_MS = exports.ONE_MINUTE_MS = exports.ONE_SECOND_MS = exports.objDateKeys = exports.dmyKeys = exports.hmsKeys = void 0

var hmsKeys = ['h', 'm', 's']
exports.hmsKeys = hmsKeys
var dmyKeys = ['y', 'M', 'd']
exports.dmyKeys = dmyKeys

var objDateKeys = dmyKeys.concat(hmsKeys)
exports.objDateKeys = objDateKeys

var ONE_SECOND_MS = 1000
exports.ONE_SECOND_MS = ONE_SECOND_MS
var ONE_MINUTE_MS = ONE_SECOND_MS * 60
exports.ONE_MINUTE_MS = ONE_MINUTE_MS
var ONE_HOUR_MS = 60 * ONE_MINUTE_MS
exports.ONE_HOUR_MS = ONE_HOUR_MS
var ONE_DAY_MS = 24 * ONE_HOUR_MS
exports.ONE_DAY_MS = ONE_DAY_MS

var MAX_SEC_IN_DAY = ONE_DAY_MS / 1000 - 1
exports.MAX_SEC_IN_DAY = MAX_SEC_IN_DAY
var MAX_SEC_IN_HOUR = ONE_HOUR_MS / 1000 - 1
exports.MAX_SEC_IN_HOUR = MAX_SEC_IN_HOUR

var DEFAULT_FMT_MASK = 'd M `y h:m'
exports.DEFAULT_FMT_MASK = DEFAULT_FMT_MASK

var maxPartVals = {
  y: 9999,
  M: 11,
  d: 31,
  h: 23,
  m: 59,
  s: 59,

  ms: 999,
  D: 6,
  w: 52
}
exports.maxPartVals = maxPartVals

var consts = {
  MAX_SEC_IN_DAY: MAX_SEC_IN_DAY,
  MAX_SEC_IN_HOUR: MAX_SEC_IN_HOUR,
  ONE_SECOND_MS: ONE_SECOND_MS,
  ONE_MINUTE_MS: ONE_MINUTE_MS,
  ONE_HOUR_MS: ONE_HOUR_MS,
  ONE_DAY_MS: ONE_DAY_MS,
  hmsKeys: hmsKeys,
  dmyKeys: dmyKeys,
  objDateKeys: objDateKeys,
  maxPartVals: maxPartVals
}
var _default = consts
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/consts.js
// module id = 64
// module chunks = 0